import SettingsCredentialsList from './list'


if (document.body.getAttribute("data-current-path") === "settings/credentials") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new SettingsCredentialsList();
    }
}